<template>
    <tr
        :class="[{ 'is-clickable': clickable, 'is-selected': selected }, rowClass]"
        @click="$emit('select', item)"
    >
        <slot :item="item" />
    </tr>
</template>

<script>
export default {
    name: "AdminTableRow",
    props: {
        item: { type: Object, required: true },
        rowClass: { type: [String, Array, Object], default: "" },
        clickable: { type: Boolean, default: false },
        selected: { type: Boolean, default: false },
    },
};
</script>

<style scoped lang="scss">
.is-clickable {
    cursor: pointer;
}

.is-selected {
    background: #f2f7fb;
}
</style>
